import { useParams } from "react-router-dom";

import ErrorMessage from "@/ui/atoms/ErrorMessage";

import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

import { ViewExtractionReview, ViewExportModal } from "@/ui/compositionRootUI";

const PageExtractionReview = () => {
    const { projectId, databaseId, extractionId } = useParams();

    if (
        projectId === undefined ||
        extractionId === undefined ||
        databaseId === undefined
    ) {
        return (
            <LayoutFillParentCentered>
                <ErrorMessage>Invalid URL parameters</ErrorMessage>
            </LayoutFillParentCentered>
        );
    }

    return (
        <>
            <ViewExtractionReview
                projectId={Number(projectId)}
                databaseId={Number(databaseId)}
                extractionId={Number(extractionId)}
            />
            <ViewExportModal />
        </>
    );
};

export default PageExtractionReview;
